import React from "react";
import Button from "../ui/Button";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation"; // 1. Navigation CSS import ki
import { Pagination, Navigation } from "swiper/modules"; // 2. Autoplay hatakar Navigation add kiya

const AnviyaFeatures = ({
  title = "Our Features",
  features = [],
  buttonText = "Book Now",
  description = "",
}) => {
  const isSliderNeeded = features.length > 3;

  // Swiper Settings Object (Common for both conditions to keep code clean)
  const swiperSettings = {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      clickable: true,
      dynamicBullets: true,
    },
    navigation: true, // 3. Navigation enable kiya
    modules: [Pagination, Navigation], // 4. Modules update kiye
    className: "mySwiper !pb-14",
    breakpoints: isSliderNeeded
      ? {
          640: { slidesPerView: 2, spaceBetween: 20 },
          1040: { slidesPerView: 3, spaceBetween: 22 },
          1680: { slidesPerView: 3.5, spaceBetween: 24 },
        }
      : {
          640: { slidesPerView: 2, spaceBetween: 20 },
          1680: { slidesPerView: 3, spaceBetween: 24 },
        },
  };

  return (
    <section className="py-8 md:py-0 md:pb-16 px-4 bg-white relative">
      <div className="max-w-[1800px] mx-auto">
        {/* Main Heading */}
        <div className="text-center  max-w-[1023px] mx-auto">
          <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#183076]">
            {title}
          </h2>
        </div>
        <p className="mt-6 text-[14px] text-[#183076] md:text-[24px] max-w-[1099px] leading-relaxed text-center mx-auto mb-12">
          {description}
        </p>

        <Swiper {...swiperSettings}>
          {features.map((feature, index) => (
            <SwiperSlide key={index} className="h-auto">
              <div className="group relative border border-blue-100 rounded-[32px] p-8 h-[300px] lg:h-[400px] 2xl:h-[450px] flex flex-col justify-between overflow-hidden transition-all duration-500 bg-white">
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-0"
                  style={{
                    background:
                      "radial-gradient(80% 80% at 100% 100%, rgba(0, 152, 176, 0.15) 0%, rgba(0, 152, 176, 0) 100%)",
                  }}
                />

                <div className="relative z-10">
                  <h3 className="text-[20px] lg:text-[30px] font-bold text-[#183076] mb-4">
                    {feature.title}
                  </h3>
                  <p className="leading-relaxed text-[18px] lg:text-[24px]">
                    {feature.description}
                  </p>
                </div>

                <Button
                  className="relative z-10 w-fit  border border-[#183076] text-[#183076] font-semibold rounded-full hover:bg-[#183076] hover:text-white transition-all duration-300"
                  text={buttonText}
                  to={feature.link}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* 5. Custom Styling for Buttons and Pagination */}
      <style jsx global>{`
        .swiper-button-next,
        .swiper-button-prev {
          color: #183076 !important; /* Button ka color */
          background: white;
          width: 50px !important;
          height: 50px !important;
          border-radius: 50%;
          padding: 15px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          top: 50% !important;
        }

        .swiper-button-next:after,
        .swiper-button-prev:after {
          font-size: 10px !important;
          font-weight: bold;
        }

        .swiper-pagination-bullet-active {
          background: #183076 !important;
        }

        /* Mobile par buttons chhupane ke liye (optional) */
        @media (max-width: 768px) {
          .swiper-button-next,
          .swiper-button-prev {
            display: none !important;
          }
        }
      `}</style>
    </section>
  );
};

export default AnviyaFeatures;
